import axios from 'axios'
import getCookie from '@/utils/getCookie'
import setCookie from '@/utils/setCookie'

const Api = axios.create({
  baseURL: process.env.VUE_APP_API_URL + '/api',
  headers: {
    Accept: 'application/json'
  }
})

/**
 * Use request interceptor to fetch token.
 * Token is fetched asynchronously and attached to request as Authorization header.
 */
Api.interceptors.request.use(
  async config => {
    const cgToken = getCookie('cgToken')

    if (cgToken) { config.headers.Authorization = 'Bearer ' + getCookie('cgToken') }
    return config
  },
  error => Promise.reject(error)
)

/**
 * Endpoints where a 401 means "invalid credentials / code", not an expired
 * session. They must not trigger the global redirect to the login page.
 */
const SKIP_AUTH_REDIRECT_PATHS = [
  '/customer/login',
  '/customer/login-sso',
  '/customer/2fa/verify',
  '/customer/2fa/resend',
  '/customer/2fa/sms-status',
  '/customer/2fa/email-fallback',
]

/**
 * Use response interceptor to catch 401 (Unauthorized) api response.
 * If caught, refresh the token and retry the request.
 */
Api.interceptors.response.use(
  response => response.data,

  async error => {
    const { config: request, response } = error

    const requestUrl = request?.url || ''
    const skipRedirect = SKIP_AUTH_REDIRECT_PATHS.some((path) => requestUrl.includes(path))

    if (response?.status === 401 && !request?.retryRequest && !skipRedirect) {
      request.retryRequest = true

      setCookie(null, 0, 'cgToken')
      setCookie(null, 0, 'cgUserIsVendor')
      const { origin, pathname: failedPage } = window.location

      setTimeout(() => {
        window.location.href = new URL(`/auth/login?redirect=${failedPage}`, origin)
      }, 0)
    }

    throw error
  }
)

export default Api
